import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import { initOfflineSupport } from './lib/offlineStorage';

// Initialize offline support
initOfflineSupport();

// Create root outside of render to persist between HMR updates
const root = createRoot(document.getElementById('root')!);

// Handle navigation restoration — preserve search params (OAuth codes live here)
if (window.location.pathname !== '/' && !window.location.hash) {
  const path = window.location.pathname + window.location.search;
  window.history.replaceState(null, '', '/');
  window.history.pushState(null, '', path);
}

// Render app
root.render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);